<svelte:options
    customElement={{
        tag: "nvbs-searchengine",
        props: {
            url: { reflect: true, type: 'String' },
            token: { reflect: true, type: 'String' },
        },
    }}
 />


<script lang="ts">
    import { onMount } from 'svelte';
    import {SearchEngineUrlState} from "./lib/common/SearchEngineUrlState";
    import App from './App.svelte';
    import Loading from "./lib/components/Loading.svelte";
    import * as Sentry from "@sentry/svelte";

    let { url = '', token = '' }: { url?: string; token?: string } = $props();
    let initialState = $state();
    let isReady = $state(false);
    let attributes = $state({});


    onMount(() => {
        initialState = SearchEngineUrlState.Get();
        let attributeElement = document.querySelector('.nvbs-searchengine-attributes');
        attributes = JSON.parse(attributeElement?.textContent || '{}');

        isReady = true;

        if(import.meta.env.VITE_SENTRY_DSN) {
            Sentry.init({
                dsn: import.meta.env.VITE_SENTRY_DSN,
                environment : import.meta.env.VITE_SENTRY_ENVIRONMENT,
                // Adds request headers and IP for users, for more info visit:
                // https://docs.sentry.io/platforms/javascript/guides/svelte/configuration/options/#sendDefaultPii
                sendDefaultPii: true,
                integrations: [
                    Sentry.browserTracingIntegration(),
                ],
                // Set tracesSampleRate to 1.0 to capture 100%
                // of transactions for tracing.
                // We recommend adjusting this value in production
                // Learn more at
                // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
                tracesSampleRate: 0.1,
            });
        } else {
            console.warn('Sentry DSN not provided, skipping Sentry initialization.');
        }
    });
</script>




{#if isReady}
    <App
            {url}
            {token}
            {initialState}
            {attributes}
    />
{/if}

<style global lang="scss">
    @forward "css/global.scss";
</style>